<div class="coloured-dot" #colouredCircle></div><span>{{ text }}</span>
